module.exports = __webpack_public_path__ + "6cb19857a0f9aee9f71de9b6cf4f1e47.png";